import { HTMLAttributes } from "react";
import { useSpring, animated } from "react-spring";

interface BouncingLoaderProps extends HTMLAttributes<HTMLDivElement> {
  width: string;
  height: string;
  delay?: number;
}

const BouncingLoader = ({ delay, ...divProps }: BouncingLoaderProps) => {
  const { opacity } = useSpring({
    from: { opacity: 1 },
    to: { opacity: 0.1 },
    config: { tension: 140 },
    delay: delay ?? 0,
    loop: true,
  });

  return (
    <animated.div
      style={{
        ...divProps,
        backgroundColor: 'black',
        opacity,
        borderRadius: "50%",
      }}
    />
  );
};

export default BouncingLoader;
